export default {
  MuiCheckbox: {
    root: {}
  }
};
